import React from 'react'

import styled from 'styled-components'
import { DefaultTheme } from 'styled-components/dist/types'

import { variables } from 'src/Styled/variables'
import CheckIcon from 'src/Assets/Svg/common/check-mark.svg?react'
import TimeIcon from 'src/Assets/Svg/campaign-statuses-icons/Time.svg?react'
import { ReviewTypeStatus } from 'src/Hooks/useCampaignDetailsReviews'
import ErrorIcon from 'src/Assets/Svg/common/error.svg?react'

const STATUS_CONFIG: Record<
  ReviewTypeStatus,
  {
    label: string
    icon: React.ReactNode
    bg: (theme: DefaultTheme) => string
    textColor: (theme: DefaultTheme) => string
  }
> = {
  placement: {
    label: 'Placement',
    icon: <CheckIcon />,
    bg: (theme) => theme.color.lightGreen,
    textColor: (theme) => theme.color.darkGreen,
  },
  feedback: {
    label: 'Feedback',
    icon: null,
    bg: (theme) => theme.color.lightGrey,
    textColor: (theme) => theme.color.darkGrey,
  },
  notReviewed: {
    label: 'Not reviewed',
    icon: <ErrorIcon />,
    bg: (theme) => theme.color.lightRed,
    textColor: (theme) => theme.color.darkRed,
  },
  awaiting: {
    label: 'Awaiting',
    icon: <TimeIcon />,
    bg: (theme) => theme.color.hoverWhite,
    textColor: (theme) => theme.color.slateGrey,
  },
}

const Container = styled.div<{
  $status: ReviewTypeStatus
}>`
  display: flex;
  height: 24px;
  padding: 0px 6px;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  background-color: ${({ theme, $status }) => STATUS_CONFIG[$status].bg(theme)};

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${({ theme, $status }) => STATUS_CONFIG[$status].textColor(theme)};
    }
  }
`

const Text = styled.span<{
  $status: ReviewTypeStatus
}>`
  color: ${({ theme, $status }) => STATUS_CONFIG[$status].textColor(theme)};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize12};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  word-break: break-word;
`

interface ReviewTypeProps {
  status: ReviewTypeStatus
  className?: string
}

export const ReviewType: React.FC<ReviewTypeProps> = ({
  status,
  className,
}) => (
  <Container $status={status} className={className}>
    {STATUS_CONFIG[status].icon}
    <Text $status={status}>{STATUS_CONFIG[status].label}</Text>
  </Container>
)
